import ClubTransactionInvoice from './ClubTransactionInvoice';

export default class ClubTransactionFinleap {
    static fromData(data) {
        if (!data) {
            return;
        }
        const clubTransactionFinleap = new ClubTransactionFinleap();
        clubTransactionFinleap.id = data.id;
        clubTransactionFinleap.transactionId = data.transactionId;
        clubTransactionFinleap.createdAt = data.createdAt;
        clubTransactionFinleap.bookedAt = data.bookedAt;
        clubTransactionFinleap.name = data.name;
        clubTransactionFinleap.formattedMoney = data.formattedMoney;
        clubTransactionFinleap.currency = data.currency;
        clubTransactionFinleap.amount = {
            numerator: data.amount.data.numerator,
            denominator: data.amount.data.denominator,
        };
        clubTransactionFinleap.outgoingPayment = data.outgoingPayment;
        clubTransactionFinleap.bookingText = data.bookingText;
        clubTransactionFinleap.purpose = data.purpose;
        clubTransactionFinleap.bankCode = data.bankCode;
        clubTransactionFinleap.accountNumber = data.accountNumber;
        clubTransactionFinleap.iban = data.iban;
        clubTransactionFinleap.bic = data.bic;
        clubTransactionFinleap.invoices = data.invoices.data.map((transactionInvoice) => {
            return ClubTransactionInvoice.fromData(transactionInvoice);
        });

        return clubTransactionFinleap;
    }
}
